import { Entitlements } from '@trello/entitlements';

import { isAdminOfOrganization } from '../organization/isAdminOfOrganization';
import type { canEdit } from './canEdit';
import { getMemberTypeFromBoard } from './getMemberTypeFromBoard';

/**
 * Checks if a member has permissions to rename the board.
 */
export const canRename = (
  member: {
    id: string;
    idEnterprisesAdmin: Array<string>;
    idPremOrgsAdmin: Array<string>;
    memberType: 'ghost' | 'normal';
  },
  board: {
    memberships: {
      id: string;
      deactivated: boolean;
      idMember: string;
      memberType: 'admin' | 'normal' | 'observer';
      unconfirmed: boolean;
    }[];
  },
  organization: Parameters<typeof canEdit>[2],
  enterprise: Parameters<typeof canEdit>[3],
): boolean => {
  // Member is a board admin
  const boardAdmin =
    getMemberTypeFromBoard(member, board, organization) === 'admin';
  // Member is a workspace admin in a paid org
  const workspaceAdmin =
    organization &&
    !Entitlements.isFree(organization.offering) &&
    isAdminOfOrganization(member, organization, enterprise);

  if (boardAdmin || workspaceAdmin) {
    return true;
  } else {
    return false;
  }
};
